import EngineeringIcon from "@mui/icons-material/Engineering";
import GroupsRoundedIcon from "@mui/icons-material/GroupsRounded";
import HikingIcon from "@mui/icons-material/Hiking";
import ScienceIcon from "@mui/icons-material/Science";

import { NavSection } from "../../components/LeftNavV2/LeftNavDrawerV2";
import { type GroupChildNavItem } from "../../components/LeftNavV2/NavItemV2";

function staffChild(text: string, path: string, description?: string): GroupChildNavItem {
  return {
    kind: "GroupChild",
    text,
    path,
    variant: "staff",
    description,
  };
}

export function useStaffNavSectionsV2(): NavSection[] {
  const customersChildren: GroupChildNavItem[] = [
    staffChild(
      "Organizations",
      "staff/implementation",
      "Manage organization setup, implementation details, and account context."
    ),
    staffChild(
      "Payments",
      "staff/payments",
      "Review payment records and reconcile report-level transactions."
    ),
    staffChild(
      "Subscriptions",
      "staff/subscription-overview",
      "Compare SFDC contracted subscription tiers and facility counts against Encamp actuals."
    ),
    staffChild(
      "Feature Flags",
      "staff/feature-flags",
      "Manage Encamp-managed feature flags across organizations."
    ),
    staffChild(
      "Roles",
      "staff/roles",
      "Edit the permissions of an organization's roles, and create or remove roles."
    ),
    staffChild("Insights Demo", "staff/insights-demo-org-creator"),
  ];

  const complianceChildren: GroupChildNavItem[] = [
    staffChild(
      "Fulfillment",
      "staff/fulfillment",
      "Monitor report progress, assignments, and workflow outcomes."
    ),
    staffChild(
      "Generator Statuses",
      "staff/generator-status-changes",
      "Monitor potential generator status discrepancies across facilities."
    ),
    staffChild(
      "CERS",
      "staff/cers",
      "Review CERS submittal decisions, track CUPA rejections, and match scraped CERS facilities to Encamp."
    ),
    staffChild("Requirements", "staff/requirements"),
    staffChild(
      "Agencies",
      "staff/agencies",
      "Maintain LEPC, fire department, and state agency records."
    ),
    staffChild(
      "Mail Room",
      "staff/mail-room",
      "Create and track customer communications and delivery status."
    ),
    staffChild(
      "Credentials",
      "staff/credentials",
      "Manage EPCRA, RCRAInfo, and STEERS credential implementations."
    ),
  ];

  const platformChildren: GroupChildNavItem[] = [
    staffChild("Observe", "staff/observe", "Monitor Scout diagnostics and run Scout load tests."),
    staffChild("Jobs", "staff/jobs"),
    staffChild("Pipelines", "staff/pipelines"),
    staffChild("Workflow Config", "staff/workflow-config"),
    staffChild("Tags", "staff/tags"),
  ];

  const previewChildren: GroupChildNavItem[] = [
    staffChild("Notifications", "staff/notifications"),
    staffChild(
      "Amazon WADM",
      "staff/amazon-wadm",
      "Search and export Amazon waste generation records by site, profile, and shipment."
    ),
  ];

  return [
    {
      title: "Staff",
      variant: "staff",
      items: [
        {
          kind: "Group",
          text: "Customers",
          description: "Organizations, payments, subscriptions, and demo tooling.",
          Icon: GroupsRoundedIcon,
          path: "staff/implementation",
          isExpandable: true,
          defaultExpanded: true,
          variant: "staff",
          children: customersChildren,
        },
        {
          kind: "Group",
          text: "Compliance",
          description: "Fulfillment, requirements, agencies, mail, and credentials.",
          Icon: HikingIcon,
          path: "staff/fulfillment",
          isExpandable: true,
          defaultExpanded: true,
          variant: "staff",
          children: complianceChildren,
        },
        {
          kind: "Group",
          text: "Platform",
          description: "Observability, jobs, pipelines, workflow config, and tags.",
          Icon: EngineeringIcon,
          path: "staff/observe",
          isExpandable: true,
          defaultExpanded: true,
          variant: "staff",
          children: platformChildren,
        },
        {
          kind: "Group",
          text: "Preview",
          description: "Experimental staff tools that are still in preview.",
          Icon: ScienceIcon,
          path: "staff/notifications",
          isExpandable: true,
          defaultExpanded: true,
          variant: "staff",
          children: previewChildren,
        },
      ],
    },
  ];
}
